export default __webpack_public_path__ + "static/media/Login-page.d1dabc16.png";